
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnDestroy,
  ViewChild,

} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { Subject } from 'rxjs';

@Component({
  standalone:true,
  imports:[CommonModule,FormsModule,ReactiveFormsModule,MdbFormsModule],
  selector: 'app-mdb-textarea',
  templateUrl: './mdb-textarea.component.html',
  styleUrls: ['./mdb-textarea.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MdbTextareaComponent),
    multi: true,
  }]
})
export class MdbTextareaComponent implements AfterViewInit, OnDestroy, ControlValueAccessor {
  
  @ViewChild('textAreaElement') textAreaElement: ElementRef;
  @Input() rows: number = 6;
  @Input() maxLength: number = 512;
  @Input() label: string;
  static nextId = 0;

  @Input()
  get value(): any {
    return this.controlText.value.trim();
  }
  set value(value: any) {
    this.controlText.setValue(value);
    this.stateChanges.next();
  }
  public controlText: UntypedFormControl = new UntypedFormControl(null);

  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(placeholder) {
    this._placeholder = placeholder;
    this.stateChanges.next();
  }
  public _placeholder: string;

  @Input()
  get required(): boolean {
    return this._required;
  }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this._disabled ? this.controlText.disable() : this.controlText.enable();
    this.stateChanges.next();
  }
  private _disabled = false;

  get empty() {
    return !this.controlText.value;
  }

  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }


  public focused = false;

  public id = `textarea-component-${MdbTextareaComponent.nextId++}`;

  private onChangeCallback = (value: any) => {};
  private onTouchedCallback = () => {};


  public stateChanges = new Subject<void>();
  
  constructor(
    private _elementRef: ElementRef<HTMLElement>,
  ) {

    this.controlText.valueChanges.pipe(
      takeUntilDestroyed()
    ).subscribe(value => {
      try {
        this.onChangeCallback(value);
      } catch(e) { }
    });
  }

  ngAfterViewInit():void{
    let textArea = this.textAreaElement.nativeElement
    if(this.controlText.value !== ''){
      textArea?.classList.add('active')
    }
    this.controlText.valueChanges.subscribe(value => {
      if(this.onChangeCallback){
        this.onChangeCallback(value);
        this.toggleClassActive(value,textArea)
      }      
    });
  }
  toggleClassActive(val,inputMdb){
    if(val !== ''){
      inputMdb?.classList.add('active')
    }else{
      inputMdb?.classList.remove('active')
    }
  }

  ngOnDestroy(): void {
    this.stateChanges.complete();
  }
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: () => {}): void {
    this.onTouchedCallback = fn;
  }
  writeValue(value: string) {
    this.controlText.setValue(value)
  }
  setDescribedByIds(ids: string[]) {
    const controlElement = this._elementRef.nativeElement
      .querySelector('.app-textarea-container')!;
    controlElement.setAttribute('aria-describedby', ids.join(' '));
  }
  onContainerClick(event: MouseEvent) {
      this._elementRef.nativeElement.querySelector('textarea').focus();
      this.controlText.markAsTouched()
      this.focused = true   
  }
  onBlur(){
    this.focused = false
  }
}
